import { render, staticRenderFns } from "./menuUser.vue?vue&type=template&id=1b3ce024&scoped=true&"
import script from "./menuUser.vue?vue&type=script&lang=js&"
export * from "./menuUser.vue?vue&type=script&lang=js&"
import style0 from "./menuUser.vue?vue&type=style&index=0&id=1b3ce024&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3ce024",
  null
  
)

export default component.exports